/**
 * 平台检测工具 - 仅支持微信环境
 */

export const platformDetector = {
  /**
   * 是否为微信环境
   */
  isWeChat() {
    return /MicroMessenger/i.test(navigator.userAgent)
  },

  /**
   * 是否为移动端
   */
  isMobile() {
    return /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || window.innerWidth <= 768
  },

  /**
   * 是否为iOS设备
   */
  isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent)
  },

  /**
   * 是否为Android设备
   */
  isAndroid() {
    return /Android/i.test(navigator.userAgent)
  },

  /**
   * 获取平台类名
   */
  getPlatformClass() {
    const isMobile = this.isMobile()
    return ['platform-wechat', isMobile ? 'is-mobile' : 'is-desktop'].join(' ')
  }
}
